export const hasAnyRequiredProperty = <T>(
  requiredProperties: Partial<T> | undefined,
  properties: Partial<T> | undefined,
  defaultValue = true,
): boolean => {
  if (!(requiredProperties && properties)) {
    return defaultValue;
  }

  return Object.keys(requiredProperties).some((key) =>
    Boolean(properties[key as keyof T]),
  );
};
